/*eslint camelcase: "off"*/

import on_exit from './exit.js';
import on_entry from './load.js';

export default { on_entry, on_exit };
